








/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { namespace } from 'vuex-class'
import { ClientPolicyDto } from '../../api'
import { calculateNetPremium, calculatePremiumPayable } from '../../Calculation'
import { CoverageTypeOptions } from '@core/pages/client-management/model/metadata/GiOthers'

const clientPolicyStore = namespace('ClientPolicyStore')

@Component({
  components: {
    AppForm
  }
})
export default class PremiumDetailSection extends Vue {
  @clientPolicyStore.State
  private policy: ClientPolicyDto

  @clientPolicyStore.State
  private productMetadata: any

  private coverageTypeOptions = CoverageTypeOptions

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get ebFormStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Gross Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.grossPremium,
          set: (val) => {
            this.productMetadata.grossPremium = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'GST (%)',
        model: {
          get: () => this.productMetadata.gst,
          set: (val) => {
            this.productMetadata.gst = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Net Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.netPremium || calculateNetPremium(this.productMetadata.grossPremium, this.productMetadata.gst),
          set: (val) => {
            this.productMetadata.netPremium = val
          }
        },
        disabled: true
      }
    ]
  }

  get giTravelFormStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Gross Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.grossPremium,
          set: (val) => {
            this.productMetadata.grossPremium = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Less Discount (%)',
        model: {
          get: () => this.productMetadata.discount,
          set: (val) => {
            this.productMetadata.discount = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Premium Payable ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.premiumPayable || calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.gst),
          set: (val) => {
            this.productMetadata.premiumPayable = val
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: true
      },
      {
        label: 'GST (%)',
        model: {
          get: () => this.productMetadata.gst,
          set: (val) => {
            this.productMetadata.gst = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Net Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.netPremium,
          set: () => ({})
        },
        disabled: true
      }
    ]
  }

  get giOthersFormStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Gross Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.grossPremium,
          set: (val) => {
            this.productMetadata.grossPremium = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Less Discount (%)',
        model: {
          get: () => this.productMetadata.discount,
          set: (val) => {
            this.productMetadata.discount = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Premium Payable ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.premiumPayable || calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.gst),
          set: (val) => {
            this.productMetadata.premiumPayable = val
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: true
      },
      {
        label: 'GST (%)',
        model: {
          get: () => this.productMetadata.gst,
          set: (val) => {
            this.productMetadata.gst = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Net Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.netPremium,
          set: () => ({})
        },
        disabled: true
      },
      {
        label: 'Coverage Type',
        options: this.coverageTypeOptions,
        model: {
          get: () => this.productMetadata.coverageType,
          set: (val) => {
            this.productMetadata.coverageType = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'List of Insured',
        type: 'textarea',
        model: {
          get: () => this.productMetadata.listOfInsured,
          set: (val) => {
            this.productMetadata.listOfInsured = val
          }
        },
        classes: ['colspan'],
        rows: 10,
        disabled: this.isDisabled
      }
    ]
  }

  get giHomeContentFormStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Gross Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.grossPremium,
          set: (val) => {
            this.productMetadata.grossPremium = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Less Discount (%)',
        model: {
          get: () => this.productMetadata.discount,
          set: (val) => {
            this.productMetadata.discount = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Premium Payable ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.premiumPayable || calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.gst),
          set: (val) => {
            this.productMetadata.premiumPayable = val
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: true
      },
      {
        label: 'GST (%)',
        model: {
          get: () => this.productMetadata.gst,
          set: (val) => {
            this.productMetadata.gst = val
            this.productMetadata.premiumPayable = calculatePremiumPayable(this.productMetadata.grossPremium, this.productMetadata.discount)
            this.productMetadata.netPremium = calculateNetPremium(this.productMetadata.premiumPayable, this.productMetadata.gst)
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Net Premium ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.netPremium,
          set: () => ({})
        },
        disabled: true
      }
    ]
  }

  get formStructure (): FormStructure<ClientPolicyDto> {
    switch (this.policy.type) {
      case 'gi-homecontents':
        return this.giHomeContentFormStructure
      case 'gi-motors':
      case 'gi-motors-commercial':
        return this.giHomeContentFormStructure
      case 'gi-travel':
      case 'gi-travel-corporate':
        return this.giTravelFormStructure
      case 'gi-clines':
      case 'gi-plines':
      case 'gi-plines-corporate':
      case 'gi-health-individual':
      case 'gi-others':
        return this.giOthersFormStructure
      case 'group-gi':
      case 'group-eb':
      case 'group-eb-tailored':
      case 'gi-health-group':
      case 'employeebenefits':
        return this.ebFormStructure
      default:
        return this.giHomeContentFormStructure
    }
  }
}
